module.exports = __webpack_public_path__ + "static/media/3DPPA25.008a9095.jpg";